import a, { useState as L, useRef as T, useEffect as A } from "react";
import { useUniqueId as G } from "../../hooks/useUniqueId.js";
import { cls as J } from "../../helpers/cls.js";
import { useDebounce as z } from "./hooks/useDebounce.js";
import { Overflow as F } from "./components/Overflow.js";
import { Input as K } from "./components/Input.js";
import { OverflowContent as Q } from "./components/OverflowContent.js";
import { useClickOutside as X } from "./hooks/useClickOutside.js";
import { useNavigation as Y } from "./hooks/useNavigation.js";
var Z = Object.defineProperty,
  m = Object.getOwnPropertySymbols,
  H = Object.prototype.hasOwnProperty,
  j = Object.prototype.propertyIsEnumerable,
  M = (e, o, t) => o in e ? Z(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[o] = t,
  $ = (e, o) => {
    for (var t in o || (o = {})) H.call(o, t) && M(e, t, o[t]);
    if (m) for (var t of m(o)) j.call(o, t) && M(e, t, o[t]);
    return e;
  },
  ee = (e, o) => {
    var t = {};
    for (var l in e) H.call(e, l) && o.indexOf(l) < 0 && (t[l] = e[l]);
    if (e != null && m) for (var l of m(e)) o.indexOf(l) < 0 && j.call(e, l) && (t[l] = e[l]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const V = e => {
  const o = e,
    {
      placeholder: t,
      onChange: l,
      onTextChange: w,
      optionsList: n = [],
      debounceTime: v,
      id: g,
      initialValue: b,
      overlayMaxHeight: O,
      actionElement: P,
      label: c,
      children: p,
      showDropdownAsDefault: k,
      className: W,
      clearInput: E,
      shadow: y = !0,
      tagOverflow: _
    } = o,
    r = ee(o, ["placeholder", "onChange", "onTextChange", "optionsList", "debounceTime", "id", "initialValue", "overlayMaxHeight", "actionElement", "label", "children", "showDropdownAsDefault", "className", "clearInput", "shadow", "tagOverflow"]),
    q = G("ds-inputchips-element"),
    u = g != null ? g : q,
    [d, I] = L(b != null ? b : ""),
    [S, s] = L(!1),
    f = T(null),
    h = T(null),
    i = z(d, v != null ? v : 300),
    x = a.Children.count(p) || n.length || 0;
  X({
    wrapperRef: h,
    inputRef: f,
    setShowItems: s,
    searchTerm: d
  }), Y({
    wrapperRef: h,
    setShowItems: s,
    inputRef: f,
    childrenNumber: x
  }), A(() => {
    E && I("");
  }, [E]), A(() => {
    typeof i == "string" && l && l(i), typeof i == "string" && w && w(i);
  }, [i]);
  const C = typeof c != "undefined" && c.trim().length > 0,
    D = r.state === "loading",
    N = S && !(r != null && r.disabled) && !D && (r == null ? void 0 : r.state) !== "error" || k,
    B = S && (n.length > 0 || x > 0);
  return a.createElement("div", {
    "data-ds-component": "DS-Autocomplete",
    ref: h,
    className: J("olx-autocomplete", W)
  }, a.createElement("div", {
    className: "combobox-wrapper"
  }, a.createElement(K, $({
    elementId: u,
    label: c,
    placeholder: t,
    ariaExpanded: B,
    actionElement: P,
    isLoading: D,
    setSearchTerm: I,
    setShowItems: s,
    inputRef: f,
    searchTerm: d,
    onClick: U => {
      var R;
      s(!0), (R = r == null ? void 0 : r.onClick) == null || R.call(r, U);
    }
  }, r)), N && n.length > 0 && a.createElement(Q, {
    tagOverflow: _,
    elementId: u,
    overlayMaxHeight: O,
    hasLabel: C,
    shadow: y,
    optionsList: n
  }), N && n.length <= 0 && p && a.createElement(F, {
    tagOverflow: _,
    elementId: u,
    overlayMaxHeight: O,
    hasLabel: C,
    shadow: y
  }, p)));
};
V.displayName = "Autocomplete";
export { V as Autocomplete };